/****
 * This is the App main screen - for a reseller, this is the list of apps configured for customer onboarding.
 * For AppBind, content is TBD.
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, Link, Paper, TableContainer, Table, TableHead, TableCell, TableBody, TablePagination, TableRow, Tooltip, Typography } from '@mui/material';

import Add from '@mui/icons-material/Add';

import CheckCircle from '@mui/icons-material/CheckCircle';
import Lock from '@mui/icons-material/Lock';
import PauseCircleFilled from '@mui/icons-material/PauseCircleFilled';

import PageTitle from '../ui/PageTitle';
import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';
import SearchField from '../ui/SearchField';
import AppBindStyles from '../../AppBindStyles';
import AppLogo from '../ui/AppLogo';

import { green, blue } from '@mui/material/colors';

const abEnvironment = new AbEnvironment();
const AppSummaryTableQuery = graphql`
query AppSummaryTableQuery($accountId: UUID!, $searchParm: String!, $first: Int, $offset: Int) {
  appsearchconfiguredbyappname(accountid: $accountId, search: $searchParm, first: $first, offset: $offset) {
    totalCount
    nodes {
      appId
      accountId
      appStatus
      appName
      appSku
      appUrl
      appLogo
      description
 
   }
 }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
  },
  flex: {
    flex: 1,
  },
  button: {
    marginTop: 10
  },
  paper: {
    maxWidth: 1200,
    marginTop: '16px'
  }
});

class AppSummaryTable extends Component {
  state = {
    searchP: '',
    page: 0,
    rowsPerPage: 10
  };

  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    let sTerm = params.get('sterm');
    if (sTerm == null)
    {
      // Is there something in local storage?
      sTerm = localStorage.getItem('appsSterms');
    }

    if (sTerm == null)
      sTerm = '';

    this.setState({searchP: sTerm});
  }

  goTo(route) {
    localStorage.setItem('appsSterms', this.state.searchP);
    this.props.history.push(`/${route}`);
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };
  
  handleChangePage = (event, page) => {
    this.setState({page: page});
  }
  
  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page: 0});
  }

  render() {
    const { isAuthenticated, isAuthenticatedReseller, isAuthenticatedVendor, isAuthenticatedAppBind, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    const statusOk = green[300];
    const statusInactive = blue[300];


    // Determine the offset
    let offset = 0;
    if (this.state.page > 0)
    {
      offset = this.state.page * this.state.rowsPerPage
    }
    let first = this.state.rowsPerPage;

    let totalCount = 0;

    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    }

    if (isAuthenticatedAppBind())
    {
      return (
        <Redirect to='/home' />
      );
    }
    else if (isAuthenticatedReseller() || isAuthenticatedVendor())
    {
      let accountId = abEnvironment.getUserAttribute('a_id');

      let theSubtitle = "Remember default settings for apps you sell repeatedly.";
      if (isAuthenticatedVendor()) {
        theSubtitle = "Set up apps that will be resold in AppBind.";
      }

      return (
        <div className={classes.root}>

          <PageTitle title="App catalog" subtitle={theSubtitle}/>

          <Grid container spacing={1} direction="row" justifyContent="flex-start">
            <Grid item xs={12}>
              <Button
                color="primary"
                variant="contained"
                style={AppBindStyles.addButtonOnSearch}
                onClick={() => {this.goTo('appcreate');}}>
                <Add/> Add app
              </Button>
            </Grid>
            <Grid item>
              <SearchField
                id="searchP"
                label="Search by name"
                value={this.state.searchP}
                onChange={this.handleChange('searchP')}
              />
            </Grid>
          </Grid>

          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={AppSummaryTableQuery}
            variables={{accountId: accountId, 
                        searchParm: this.state.searchP,
                        first: first,
                        offset: offset}}
            render={({error, props})=> {
              if (error) {
                logError(error.message);
                return (
                  <ServerError/>
                );
            } else if (props) {

                // Determine offset information
                totalCount = props.appsearchconfiguredbyappname.totalCount;

                let apps = props.appsearchconfiguredbyappname.nodes;
              
                return (
                  <div  className={classes.paper}>

                    <Paper >
                      <TableContainer>
                        <Table>
                          <TableHead style={AppBindStyles.tableHead}>
                            <TableRow style={AppBindStyles.tableHeadRow}>
                              <TableCell>App</TableCell>
                              <TableCell>Description</TableCell>
                              <TableCell align="center">Status</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {apps.map(n => {
                              let theUrl = "app?appId=" + n.appId;

                              return (
                                <TableRow key={n.appId}>
                                  <TableCell>
                                    <Grid container alignItems="center" wrap="nowrap" spacing={1}>
                                      <Grid item>
                                        <AppLogo logoPath={n.appLogo} appName={n.appName} imageHeight='24px'/>
                                      </Grid>
                                      <Grid item >
                                        <Link component="button" 
                                              variant="body2"
                                              onClick={this.goTo.bind(this, theUrl)}>
                                          {n.appName}
                                        </Link>
                                        {n.appSku != null && n.appSku !== '' && n.appSku !== n.appName &&
                                          <Typography variant="body2">{n.appSku}</Typography>
                                        }
                                      </Grid>
                                    </Grid>
                                  </TableCell>
                                  <TableCell align="left">{n.description}</TableCell>
                                  <TableCell align="center">
                                    <div >
                                        { n.appStatus === 0 &&
                                        <div>
                                          <Tooltip title="Active, available for all resellers">
                                            <CheckCircle htmlColor={statusOk}/>
                                          </Tooltip>
                                        </div>
                                        }
                                        { n.appStatus === 1 &&
                                        <div>
                                          <Tooltip title="Inactive">
                                            <PauseCircleFilled htmlColor={statusInactive}/>
                                          </Tooltip>
                                        </div>
                                        }
                                        { n.appStatus === 2 &&
                                        <div>
                                          <Tooltip title="Active, available to only registered partners">
                                            <Lock htmlColor={statusOk}/>
                                          </Tooltip>
                                        </div>
                                        }
                                       { n.appStatus === 3 &&
                                        <div>
                                          <Tooltip title="Active, only available for referrals">
                                            <CheckCircle htmlColor={statusOk}/>
                                          </Tooltip>
                                        </div>
                                        }
                                    </div>

                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Paper>
                    <div style={AppBindStyles.paginationTableFooter}>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalCount}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        backIconButtonProps={{
                          'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                          'aria-label': 'Next Page',
                        }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                      />                        
                    </div>
                 </div>
                )
              }
              return (
                <div>
                  <Typography>Loading...</Typography>
                  <LoadingSpinner/>
                </div>
              );
            }}
          />
        </div>
      );
    }
    else
    {
      return (
        <Redirect to='/home' />
      );
    }
  }

}

export default withStyles(styleSheet)(AppSummaryTable);
